import React, { Component } from 'react';
import Table from '../../../../commons/Table/Table';

export default class SMSList extends Component {
    state = {
        headers: [
            {key: 'id', label: 'id'},
            {key: 'title', label: 'Title'},
            {key: 'content', label: 'Content'},
            {key: 'actions', label: 'Actions'},
        ]
    };

    render() {
        return (
            <Table id={"smsTemplateTable"} headers={this.state.headers}
                   data={this.props.smsTemplates} />
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/management/smsManager/tabs/SMSList.js
 **/